import {
  EmbeddedCheckout,
  EmbeddedCheckoutProvider,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../../shared/axios/axiosProxy.js";
import i18n from "../../../utils/i18n.js";
import "./payment.scss";

const StripeCTA = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const email = query.get("email");
  const priceId = query.get("priceId");
  const reqId = query.get("reqId");
  const [clientSecret, setClientSecret] = useState(null);
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    const initializeStripe = async () => {
      try {
        // 1) Fetch the correct publishable key based on reqId
        const paramsResponse = await axios.get(
          `/api/aspreq/get-params/${reqId}`
        );
        const { stripePublishableKey } = paramsResponse.data;

        if (!stripePublishableKey) {
          console.error("No Stripe publishable key returned from backend");
          return;
        }

        // 2) Initialize Stripe with the correct key
        const stripe = loadStripe(stripePublishableKey);
        setStripePromise(stripe);

        // 3) Create checkout session
        const response = await axios.post(
          `/api/checkout-cta/session?email=${encodeURIComponent(
            email
          )}&priceId=${encodeURIComponent(priceId)}&reqId=${encodeURIComponent(
            reqId
          )}`
        );
        setClientSecret(response.data.clientSecret);
      } catch (error) {
        console.error(
          "Stripe initialization error:",
          error.response?.data || error.message
        );
      }
    };

    if (reqId) {
      initializeStripe();
    }
  }, [email, priceId, reqId]);

  const options = {
    clientSecret,
    onComplete: () => {
      // Optionally handle completion
    },
  };

  return (
    <div className={"payment-container"}>
      <div className={"payment-content-area"}>
        <div className="payment-content-header">
          <p className="payment-header-text">
            {i18n.t("searchflow.providePaymentDetails")}
          </p>
        </div>
        <div id="checkout">
          {clientSecret && stripePromise && (
            <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          )}
        </div>
      </div>
    </div>
  );
};

export default StripeCTA;
